import { computed } from 'vue'
import { DEFAULT_ASSISTANT_NAME } from '@/constants/assistantNames'
import useUser from './useUser'

/**
 * The creator's chosen name for their assistant (`organizations.assistant_name`),
 * falling back to the product name "Lighthouse" until they've named it (or for
 * orgs that haven't been backfilled yet). Use this anywhere the UI currently
 * hardcodes "Lighthouse" to refer to the chat/inbox agent persona rather than
 * the product itself.
 */
export default function useAssistantName() {
    const { user } = useUser()

    const assistantName = computed(() => user.value?.organization?.assistant_name || DEFAULT_ASSISTANT_NAME)

    return { assistantName }
}
